module.exports = __webpack_public_path__ + "media/images/athletes/3341-dba67b38579ff956d00a3363067bc9e6.png";